@if (loadingScreenService.loading()) {
  <div class="loading-screen">
    <div class="logo-container">
      <img alt="AsseTotal logo" class="logo-image" [src]="erpLogoUrl" />
      <div class="dollar-orbit">
        @for (i of [0, 1, 2, 3, 4, 5]; track i; let idx = $index) {
          <span class="dollar" [style.--i]="idx">
            <mat-icon>attach_money</mat-icon>
          </span>
        }
      </div>
    </div>
  </div>
}
